import {
  coreExtensionData,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import appVisualizerPlugin from '@backstage/plugin-app-visualizer';
import { PlatformAdminOnly } from './PlatformAdminOnly';

/**
 * Puts the app visualizer behind the same platform-admin permission as the
 * catalog index.
 *
 * `../nav/Sidebar.tsx` only stops advertising the entry, and for the catalog we
 * already decided that hiding a link is not access control. The visualizer
 * carries no tenant data, but it draws the whole extension tree - every plugin,
 * route and override this app is wired from - which is an operator's view of
 * the product, not a tenant's.
 */
const gatedVisualizerPage = appVisualizerPlugin
  .getExtension('page:app-visualizer')
  .override({
    factory(originalFactory) {
      const original = originalFactory();
      return [
        ...original,
        coreExtensionData.reactElement(
          <PlatformAdminOnly>
            {original.get(coreExtensionData.reactElement)}
          </PlatformAdminOnly>,
        ),
      ];
    },
  });

export const appVisualizerModule = createFrontendModule({
  pluginId: 'app-visualizer',
  extensions: [gatedVisualizerPage],
});
